import { DateFormat, TimeFormat } from '@next-space/fe-api-idl';
import type { FC } from 'react';
import { useMemo } from 'react';
import type { Option } from 'src/components/option-item';
import { OptionItem } from 'src/components/option-item';
import { useAppTranslation } from '@flowus/common/i18n/use-translation';

interface Props {
  dateFormat: DateFormat;
  timeFormat: TimeFormat;
  onSelectDateFormat: (format: DateFormat) => void;
  onSelectTimeFormat: (format: TimeFormat) => void;
  disableTimeFormat?: boolean;
}

export const FormatSetting: FC<Props> = (props) => {
  const { t } = useAppTranslation();

  const dateFormatOptions: Option[] = [
    { id: DateFormat.LL, name: t('components.date_picker.format.full_date') },
    { id: DateFormat.YYYY_MM_DD, name: t('common.date_format_ymd_slash') },
    { id: DateFormat.DD_MM_YYYY, name: t('components.date_picker.format.day_month_year') },
    { id: DateFormat.MM_DD_YYYY, name: t('components.date_picker.format.month_day_year') },
    { id: DateFormat.RELATIVE, name: t('common.relative_date') },
  ];
  const timeFormatOptions: Option[] = [
    { id: TimeFormat.H_MM_A, name: t('components.date_picker.format.12_hour') },
    { id: TimeFormat.H_MM, name: t('components.date_picker.format.24_hour') },
  ];

  const dateFormatSelectedIndex = useMemo(() => {
    return dateFormatOptions.findIndex((v) => v.id === props.dateFormat);
  }, [props.dateFormat, dateFormatOptions]);
  const timeFormatSelectedIndex = useMemo(() => {
    return timeFormatOptions.findIndex((v) => v.id === props.timeFormat);
  }, [props.timeFormat, timeFormatOptions]);

  return (
    <div className="next-modal px-4 py-1 w-[250px]">
      <OptionItem
        name={t('common.date_format')}
        selectedIndex={dateFormatSelectedIndex}
        options={dateFormatOptions}
        onSelect={(option) => {
          props.onSelectDateFormat(option.id as DateFormat);
        }}
      />
      <OptionItem
        name={t('components.date_picker.format.time_format')}
        disable={props.disableTimeFormat}
        selectedIndex={timeFormatSelectedIndex}
        options={timeFormatOptions}
        onSelect={(option) => {
          props.onSelectTimeFormat(option.id as TimeFormat);
        }}
      />
    </div>
  );
};
